import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ExpensePage } from './expense';

import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [
    ExpensePage,
  ],
  imports: [
    IonicPageModule.forChild(ExpensePage),
    PipesModule
  ],
})
export class ExpensePageModule {}



// WEBPACK FOOTER //
// ./src/pages/expense/expense.module.ts